import React, { useState } from "react";
import ListOfTickets from "./NavbarItems/ListOfTickets/ListOfTickets";
import "../Css/FrontPage.css";
import { useLocation } from "react-router-dom";
import Organization from "./Organization/Organization";
import { useEffect } from "react";

//js
import { CallService, signOut, modalAlert } from "../Js/Script";
import { SetDepartment, UseDepartment } from "../Js/Context/DepartmentCntx";
import { SetCategory, UseCategory } from "../Js/Context/CategoryCntx ";
import { UseOrganizaton, SetOrganizaton } from "../Js/Context/OrganizationCntx";
import { SetUser, UseUser } from "../Js/Context/userCntx";
import { UseTicket, SetTicket } from "../Js/Context/TicketCntx";

export default function FrontPage() {
  const stDepartments = UseDepartment();
  const setStDepartments = SetDepartment();
  const stCategory = UseCategory();
  const SetStCategory = SetCategory();
  const stOrganization = UseOrganizaton();
  const setStOrganizaton = SetOrganizaton();
  const stUser = UseUser();
  const setStUser = SetUser();
  const ticket = UseTicket();
  const setTicket = SetTicket();
  useEffect(() => {
    if (ticket.NavbarItem === "exit") {
      signOut();
    }
  }, [ticket.NavbarItem]);
  //get all existance department
  const getAllDepartment = () => {
    CallService("Departments", null, "GET", false, false)
      .then((res) => {
        setStDepartments(res.departments);
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });
  };
  //get all existace category
  const getAllCategories = () => {
    CallService("Categories", null, "GET", false, false)
      .then((res) => {
        SetStCategory(res.category);
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });
  };
  //get all existace organization
  const getAllOrganization = () => {
    CallService("Organization", null, "GET", false, false)
      .then((res) => {
        setStOrganizaton(res.organization);
      })
      .catch((err) => {
        modalAlert(err.message, "خطا");
      });
  };
  //Get All users
  const getAllUsers = () => {
    if (!Object.keys(stUser).length) {
      CallService(`Users`, null, "GET", false, false)
        .then((res) => {
          setStUser(res.users);
        })
        .catch((err) => {
          modalAlert(err.message, "خطا");
        });
    }
  };
  useEffect(() => {
    if (!stDepartments) {
      getAllDepartment();
    }
  }, [stDepartments]);
  useEffect(() => {
    if (!stCategory) {
      getAllCategories();
    }
  }, [stCategory]);
  useEffect(() => {
    if (!stOrganization) {
      getAllOrganization();
    }
  }, [stOrganization]);
  useEffect(() => {
    getAllUsers();
  }, [stUser]);
  return (
    <div id="front-page">
      <div id="dvTickets">
        {(ticket.NavbarItem == "tickets" || ticket.ContractSide=="tickets") && (
          <ListOfTickets
            searchTickets={ticket.SearchTickets ? ticket.SearchTickets : null}
            navbarItem={ticket.NavbarItem}
          />
        )}
        {ticket.NavbarItem == "organization" && (
          <Organization
            searchTickets={ticket.SearchTickets ? ticket.SearchTickets : null}
            navbarItem={ticket.NavbarItem}
          />
        )}
      </div>
    </div>
  );
}
